import React from 'react'
import { LanguageConstants } from '../constants/LanguageConstants'
import { useSelector } from 'react-redux'
import logo from "../Assets/images/main-logo.svg"
import logo2 from "../Assets/images/short-logo-white.svg"


function WelcomeMessage(props:any) {
 
    const profiledata = useSelector((state:any)=>state?.ProfileState)

  return (
    <div className="modal fade com-modal text-center show" id="welcomeMessageModal" aria-labelledby="welcomeMessageModalLabel" aria-hidden="true" style={{display: "block"}} >
    <div className="modal-dialog modal-dialog-centered modal-xl ">
        <div className="modal-content">
            <div className="modal-header border-0 pb-0">
                <h5 className="modal-title" id="welcomeMessageModalLabel"></h5>
                <button onClick={()=>props?.setShow(false)} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
            </div>
            <div className="modal-body pb-4 text-center">
                <img className='m-logo mb-4' src={logo} alt="" />
                <h4 className='fw-500 mb-4'>
                    {LanguageConstants?.NOTIFACTION_TITAL}
                </h4>
                <p className="mt-2">{LanguageConstants?.NOTIFACTION_FIRST_DESC}</p>
                <p className="mt-2">{LanguageConstants?.USERNAME} : {profiledata?.data?.data?.email}</p>
                <p className="mt-2">{LanguageConstants?.NOTIFACTION_THIRD}</p>
            </div>
        </div>
    </div>
</div>
  )
}

export default WelcomeMessage